<template>
  <div>
    <div>
      <el-table
        ref="multipleTable"
        :data="detailData.supplierInvoiceGeneratorList"
        tooltip-effect="dark"
        style="width: 100%"
        border
      >
        <el-table-column prop="orderNum" label="订单/支付单" min-width="140px"> 
          <template slot-scope="scope">
            <div v-if="[20,30].includes(scope.row.sourceType)">
              {{scope.row.orderNo || '---' }}
            </div>
            <div v-else>
              {{scope.row.sourceId || '---' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="prodCodeStr" label="产品名称" min-width="140px"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.prodCodeStr || '---' }}
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="payTypeStr" label="资金类型">
          <template slot-scope="scope">
            <div>
              {{scope.row.payTypeStr || '---' }}
            </div>
          </template>  
        </el-table-column>
        <el-table-column prop="taxRate" label="服务生效时间"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.startDate | format('YYYY-MM-DD') }}
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="taxRate" label="服务失效时间"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.endDate | format('YYYY-MM-DD') }}
            </div>
          </template> 
        </el-table-column>
        <!-- <el-table-column prop="taxRate" label="税率"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.taxRate || '---' }}
            </div>
          </template> 
        </el-table-column> -->
        <!-- <el-table-column prop="realReceiptAmount" label="实付金额"> 
          <template slot-scope="scope">
            <div>
              ￥{{scope.row.realReceiptAmount | formatMoney }}
            </div>
          </template> 
        </el-table-column> -->
        <el-table-column prop="realReceiptAmount" label="金额"> 
          <template slot-scope="scope">
            <div>
              ￥{{scope.row.realReceiptAmount | formatMoney }}
            </div>
          </template> 
        </el-table-column>
        <el-table-column prop="payTime" label=" 支付时间" width="160px"> 
          <template slot-scope="scope">
            <div>
              {{scope.row.payTime | format('YYYY-MM-DD HH:mm:ss') }}
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

  </div>
</template>

<script>

export default {
  props:{
    detailData:{
      type:Object,
      default:{}
    }
  },
  data() {
    return {
      multipleSelection: [],
      dialogVisible: false,
      SpanMethodProps:{
        row: '',
        column: '',
        rowIndex: 0,
        columnIndex: 0,
      },
      
    };
  },
  mounted(){
    // this.handleTableData(this.tableData)
  },
  methods: {
    
  },
};
</script>

<style lang="scss" scoped>
.detail {
  margin: 20px 0;
}

</style>